import React from 'react';
import { Card, ListGroup, Accordion, Stack, Badge } from 'react-bootstrap';
import { useAccordionButton } from 'react-bootstrap/AccordionButton';
import { ShowMore } from '../../utils/Elements/ShowMore';
import '../Pages.css';
import './Orders.css';

const CustomToggle = ({ children, eventKey }) => {
  //const decoratedOnClick = useAccordionButton(eventKey, () => console.log(eventKey + 'Custom Toggle Clicked'));
  const decoratedOnClick = useAccordionButton(eventKey);

  return (
    <Card.Header onClick={decoratedOnClick} style={{ cursor: 'pointer' }}>
      {children}
    </Card.Header>
  );
};

const buildShowMoreObj = (trackingNumberURL) => {
  if (!trackingNumberURL) {
    return [];
  }
  const urls = trackingNumberURL.split('<br />');
  return urls.map(url => {
    const trackingNumMatch = url.match(/TrackingNum=([^&<]+)/);
    const trackingNum = trackingNumMatch ? trackingNumMatch[1] : 'Tracking Link';
    return {
      label: trackingNum,
      link: url
    };
  });
};

export const OrderCard = ({ order, eventKey }) => {
  const showMoreObj = buildShowMoreObj(order.TrackingNumberURL);
  return (
  <Accordion defaultActiveKey="0">
    <Card>
      <CustomToggle eventKey={eventKey}>
        <div className='order-card-title'>
          <div className='order-title-grid'>
            <div className='order-title-group-1'>
              {order.OrderIDLineNum}
            </div>
            <div className='order-title-group-2'>
              <Stack direction="verticle" gap={2}>
                <Badge bg="secondary">{order.OrderStatusDescription}</Badge>
                <Badge bg="secondary">{order.Advertiser}</Badge>
              </Stack>
            </div>
          </div>
        </div>
      </CustomToggle>
      <Accordion.Collapse eventKey={eventKey}>
        <Card.Body>
          <div className='card-grid'>
            <div className='card-item-1'>
              <ListGroup className="list-group-flush">
                <ListGroup.Item><div className='orders-text-row'><div className='card-bold'>Line Total Cost</div> <div className='card-text'>{order.OrderLineCost.toLocaleString('en-US', { style: 'currency', currency: 'USD' })}</div></div></ListGroup.Item>
                <ListGroup.Item><div className='orders-text-row'><div className='card-bold'>Qty. | Product</div> <div className='card-text'>{order.Qty} | {order.ProductDisplayName}</div></div></ListGroup.Item>
                <ListGroup.Item><div className='orders-text-row'><div className='card-bold'>Live Size</div><div className='card-text'>{order.ImageSizeLive}</div></div></ListGroup.Item>
                <ListGroup.Item><div className='orders-text-row'><div className='card-bold'>Finished Size</div><div className='card-text'>{order.ImageSizeFinished}</div></div></ListGroup.Item>
                <ListGroup.Item><div className='orders-text-row'><div className='card-bold'>Advertiser</div> <div className='card-text'>{order.Advertiser}</div></div></ListGroup.Item>
                <ListGroup.Item><div className='orders-text-row'><div className='card-bold'>Design</div> <div className='card-text'>{order.Design}</div></div></ListGroup.Item>
                <ListGroup.Item><div className='orders-text-row'><div className='card-bold'>Unit #(s)</div> <div className='card-text'>{order.UnitNumbers}</div></div></ListGroup.Item>
              </ListGroup>
            </div>
            <div className='card-item-2'>
            <ListGroup className="list-group-flush">
                <ListGroup.Item><div className='text-row'><div className='card-bold'>Ship Method</div><div className='card-text'>{order.ShipMethodDescription}</div></div></ListGroup.Item>
                <ListGroup.Item><div className='text-row'><div className='card-bold'>Address</div></div></ListGroup.Item>
                <ListGroup.Item className='shipping-list-group'><div className='row'><div className='col-md-12'>{order.ShipTo}<br/>{order.ShipToPerson}<br/>{order.ShipToAddress1}<br/>{order.ShipToAddress2}<br/>{order.ShipToCity}, {order.ShipToState} {order.ShipToZip}</div></div></ListGroup.Item>
                <ShowMore showMoreText="Tracking" showMoreObj={showMoreObj}/>
            </ListGroup>
            </div>
          </div>
          <div className='order-card-grid-4col mt-5'>
          <div className='card-item-1'>
              <ListGroup className="list-group-flush">
                <ListGroup.Item>
                  <div className='text-row'>
                    <div className='card-bold'>Proof Preview</div>
                  </div>
                </ListGroup.Item>
                <ListGroup.Item>
                  {order.ProofLink ? (
                    <div id={`proofImage_${order.OrderIDLineNum}`} className='text-row'>
                      <a href={order.ProofLink.replace('.jpg', '.pdf')} target='_blank' rel='noopener noreferrer'>
                        <img
                          src={order.ProofLink}
                          alt='Proof Preview'
                          className='preview-image'
                          style={{ maxWidth: '350px' }}
                          onLoad={(e) => {
                            e.target.style.display = 'block';
                            const divNoPreview = document.getElementById(`noPreview_${order.OrderIDLineNum}`);
                            if (divNoPreview) {
                              divNoPreview.classList.add('hideProofImage');
                            }
                          }}
                          onError={(e) => {
                            e.target.style.display = 'none'; // Hide the broken image
                            const divNoPreview = document.getElementById(`noPreview_${order.OrderIDLineNum}`);
                            if (divNoPreview) {
                              divNoPreview.classList.remove('hideProofImage');
                            }
                          }}
                        />
                      </a>
                      <div id={`noPreview_${order.OrderIDLineNum}`} className='text-row hideProofImage'><div className='card-text'>No Preview Available</div></div>
                    </div>
                  ) : (
                    <div className='text-row'>
                      <div className='card-text'>No Preview Available</div>
                    </div>
                  )}
                </ListGroup.Item>
              </ListGroup>
            </div>
            <div className='card-item-2'>
              <ListGroup className="list-group-flush">
                  <ListGroup.Item><div className='dates-text-row'><div className='card-bold'>Dates</div></div></ListGroup.Item>
                  <ListGroup.Item><div className='dates-text-row'><div className='card-bold'>Order</div><div className='card-text'>{new Date(order.OrderDate).toLocaleDateString('en-US', {month: '2-digit',day: '2-digit',year: 'numeric',weekday: 'short'})}</div></div>
                  <div className='dates-text-row'><div className='card-bold'>{order.ShipDisplayLabel}</div><div className='card-text'>{new Date(order.ShipDisplayValue).toLocaleDateString('en-US', {month: '2-digit',day: '2-digit',year: 'numeric',weekday: 'short'})}</div></div>
                  <div className='dates-text-row'><div className='card-bold'>{order.DeliveryDisplayLabel}</div><div className='card-text'>{new Date(order.DeliveryDisplayValue).toLocaleDateString('en-US', {month: '2-digit',day: '2-digit',year: 'numeric',weekday: 'short'})}</div></div>
                  <div className='dates-text-row'><div className='card-bold'>Post</div><div className='card-text'>{new Date(order.PostDate).toLocaleDateString('en-US', {month: '2-digit',day: '2-digit',year: 'numeric',weekday: 'short'})}</div></div></ListGroup.Item>
              </ListGroup>
            </div>
            <div className='card-item-3'>
                {((typeof order.ClientPO === 'string' && order.ClientPO.length > 0) ||
                  (typeof order.ClientJobRef === 'string' && order.ClientJobRef.length > 0) ||
                  (typeof order.ContractNum === 'string' && order.ContractNum.length > 0) ||
                  (typeof order.LineItem_Custom1 === 'string' && order.LineItem_Custom1.length > 0) ||
                  (typeof order.LineItem_Custom2 === 'string' && order.LineItem_Custom2.length > 0) ||
                  (typeof order.SequenceNum === 'string' && order.SequenceNum.length > 0)) ? (
                    <ListGroup className="list-group-flush">
                      <ListGroup.Item>
                        <div className='text-row'>
                          <div className='card-bold'>References</div>
                        </div>
                      </ListGroup.Item>
                      <ListGroup.Item>
                        {typeof order.ClientPO === 'string' && order.ClientPO.length > 0 ? (
                          <div className='references-text-row'>
                            <div className='card-bold'>Order PO</div>
                            <div className='card-text'>{order.ClientPO}</div>
                          </div>
                        ) : null}
                        {typeof order.ClientJobRef === 'string' && order.ClientJobRef.length > 0 ? (
                          <div className='references-text-row'>
                            <div className='card-bold'>Order Ref.</div>
                            <div className='card-text'>{order.ClientJobRef}</div>
                          </div>
                        ) : null}
                        {typeof order.ContractNum === 'string' && order.ContractNum.length > 0 ? (
                          <div className='references-text-row'>
                            <div className='card-bold'>Order Contract</div>
                            <div className='card-text'>{order.ContractNum}</div>
                          </div>
                        ) : null}
                        {typeof order.LineItem_Custom1 === 'string' && order.LineItem_Custom1.length > 0 ? (
                          <div className='references-text-row'>
                            <div className='card-bold'>Order Space</div>
                            <div className='card-text'>{order.LineItem_Custom1}</div>
                          </div>
                        ) : null}
                        {typeof order.LineItem_Custom2 === 'string' && order.LineItem_Custom2.length > 0 ? (
                          <div className='references-text-row'>
                            <div className='card-bold'>Order Production</div>
                            <div className='card-text'>{order.LineItem_Custom2}</div>
                          </div>
                        ) : null}
                        {typeof order.SequenceNum === 'string' && order.SequenceNum.length > 0 ? (
                          <div className='references-text-row'>
                            <div className='card-bold'>Order Sequence #</div>
                            <div className='card-text'>{order.SequenceNum}</div>
                          </div>
                        ) : null}
                      </ListGroup.Item>
                    </ListGroup>
                  ) : null}

            </div>
            <div className='card-item-4'>
              {((typeof order.IndividualNameSalesContact === 'string' && order.IndividualNameSalesContact.length > 0) ||
                (typeof order.IndividualNameGraphicsContact === 'string' && order.IndividualNameGraphicsContact.length > 0)) ? (
                  <ListGroup className="list-group-flush">
                    <ListGroup.Item>
                      <div className='row'>
                        <div className='card-bold'>Contacts</div>
                      </div>
                    </ListGroup.Item>
                    <ListGroup.Item>
                      {typeof order.IndividualNameSalesContact === 'string' && order.IndividualNameSalesContact.length > 0 ? (
                        <div className='text-row'>
                          <div className='card-bold'>Order</div>
                          <div className='card-text'>{order.IndividualNameSalesContact}</div>
                        </div>
                      ) : null}
                      {typeof order.IndividualNameGraphicsContact === 'string' && order.IndividualNameGraphicsContact.length > 0 ? (
                        <div className='text-row'>
                   
                            <div className='card-bold'>Art</div>
                      
                     
                            <div className='card-text'>{order.IndividualNameGraphicsContact}</div>
                
                        </div>
                      ) : null}
                    </ListGroup.Item>
                  </ListGroup>
                ) : null}
            </div>
          </div>
        </Card.Body>
      </Accordion.Collapse>
    </Card>
  </Accordion>
)};